import { useMemo } from 'react'

/**
 * Given an activeTabLanguage, should we allow recommendation cards to be
 * interacted with and automations to be run? This was isLanguageEnglish in
 * 1.0.
 */
export function getLanguageLocked(
  activeTabLanguage: string | null | undefined,
): boolean | undefined {
  // Still loading
  if (activeTabLanguage === undefined) {
    return undefined
  }
  // Default to unlocked
  if (activeTabLanguage === null) {
    return false
  }
  // Recommendation cards and automations are unlocked for any variant of
  // English
  if (activeTabLanguage.startsWith('en')) {
    return false
  }
  // Any non-English language locks recommendation cards and automations
  return true
}

/**
 * Given an activeTabLanguage, should we allow recommendation cards to be
 * interacted with and automations to be run? This was isLanguageEnglish in
 * 1.0.
 */
export function useLanguageLocked(
  activeTabLanguage: string | null | undefined,
): boolean | undefined {
  return useMemo(
    () => getLanguageLocked(activeTabLanguage),
    [activeTabLanguage],
  )
}
